import { render, staticRenderFns } from "./ResetConfirm.vue?vue&type=template&id=689feaba&"
import script from "./ResetConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports